export default __webpack_public_path__ + "static/media/information (1) 1.f85164a0.svg";